import React, { Component } from 'react';
// import DateSelect from './dateSelect.js';
import {Form, Row, Col, Button } from 'react-bootstrap';
// import { discount } from './discount';
var $ = require('jquery');

class ArrayFormFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputs: this.props.data
    };
  }

  createFormFieldRow(input, index) { // passed in as a prop
    return (
      this.props.rowFunction(input, index)
    )
  }

  appendInput() {
    var newInput = `input-${this.state.inputs.length}`;
    this.setState({ inputs: this.state.inputs.concat([newInput]) });
  }

  removeInput(index) { // not fully working, removes final one
    // var inputs = this.state.inputs;
    // inputs.splice(index,1);
    // this.setState({inputs: inputs});
    // if (index > -1) {
    //     inputs.splice(index, 1);
    // }
    // this.setState({ inputs: inputs});
    var inputs = this.state.inputs;
    inputs.pop();
    this.setState({ inputs });
  }

  gatherInputs() {
    console.log(document.getElementsByName('arrayformfield'));
    return document.getElementsByName('arrayformfield');
  }

  render() {
    return (
      <div>
        <Form>
            {this.state.inputs.map((input, index) => this.createFormFieldRow(input, index))}
        </Form>
        <br />
        <Row>
          <Col sm={4}>
            <Button className="orange-outline"  onClick={() => this.appendInput()}>
              ADD NEW PROMOTION CODE
            </Button>
          </Col>
          <Col sm={4}>{
            this.state.inputs.length !== 0 ? (
              <Button className="orange-outline" onClick={() => this.removeInput()}>
                REMOVE LAST
              </Button>
            ) : ''
            }
          </Col>
        </Row>
        <br />
        <Row>
          <Col sm={4}>{
            this.state.inputs.length !== 0 ? (
              <Button className="orange-outline" onClick={this.props.action.bind(this,this.gatherInputs())}>
                SAVE PROMOTION CODES
              </Button>
            ) : ''
            }
          </Col>
        </Row>
        {/*
        <Button onClick={this.props.action.bind(this,this.gatherInputs())}>
            Save
        </Button> */}
      </div>
    )
  }
}

export default ArrayFormFields
